import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton,
    Typography, Tooltip
} from '@mui/material';
import { FaTrash, FaEdit } from 'react-icons/fa';

const DoctorsTable = ({ doctors, onEdit, onDelete }) => {
    return (
        <div className={'container'}>
            <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 1 }}>
                <Table sx={{ minWidth: 650 }} aria-label="doctors table">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#449998' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>First Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Last Name</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Title</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Phone</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Email</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {doctors.length > 0 ? doctors.map((doctor) => (
                            <TableRow
                                key={doctor.id}
                                sx={{
                                    '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' },
                                    '&:hover': { backgroundColor: 'rgba(68,153,152,0.09)', cursor: 'pointer' },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {doctor.name}
                                </TableCell>
                                <TableCell>{doctor.lastname}</TableCell>
                                <TableCell>{doctor.title}</TableCell>
                                <TableCell>{doctor.phone}</TableCell>
                                <TableCell>{doctor.email}</TableCell>
                                <TableCell align="center">
                                    <Tooltip title="Edit Doctor" placement="top">
                                        <IconButton color="primary" onClick={() => onEdit(doctor)}>
                                            <FaEdit />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Doctor" placement="top">
                                        <IconButton color="secondary" onClick={() => onDelete(doctor)}>
                                            <FaTrash />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body1" color="textSecondary">No doctors found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default DoctorsTable;
